var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"task-detail-main"},[(_vm.isMobile)?[_c('detailMobile')]:[_c('detailPc')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }